
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.07 27.51c.29-.15 7.16-3.72 11.37-9.75a3 3 0 000-3.53c-4.22-6-11.08-9.6-11.37-9.75a4.6 4.6 0 00-4 0 3.39 3.39 0 00-2 3v17.09a3.39 3.39 0 002 3 4.6 4.6 0 004-.06z"}})])
          )
        }
      }
    